module.exports = __webpack_public_path__ + "img/Feeding.2d3cf93d.png";